import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
// This Module's Components
import { SavedSearchesComponent } from './saved-searches.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot(), TabsModule.forRoot()],
  declarations: [SavedSearchesComponent],
  exports: [SavedSearchesComponent]
})
export class SavedSearchesModule {}
